export const columns: any = (t: any) => [
    {
        title: t('Product'),
        dataIndex: 'product',
        key: 'product',
        width: 250,
    },
    {
        title: '',
        dataIndex: 'badge',
        key: 'badge',
        width: 150,
    },
    {
        title: t('Unique ID'),
        dataIndex: 'unique_id',
        key: 'unique_id',
        width: 150,
    },
    {
        title: t('Variants'),
        dataIndex: 'variants',
        key: 'variants',
        width: 150,
        align: 'center',
    },
];

export const variantsColumns = (t: any) => [
    {
        title: t('Variants'),
        dataIndex: 'variant_title',
        key: 'variant_title',
        width: '60%'
    },
    {
        title: t('Unique ID'),
        dataIndex: 'unique_id',
        key: 'unique_id',
        width: '40%'
    },
];